export const getParam = (name: string, href?: string): string => {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let realparams = decodeURIComponent(window.location.search.substr(1));
  if (href && href.indexOf("?") > -1) {
    realparams = href.split("?")[1];
  }
  const r = realparams.match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return "";
};

export const updateLinkParams = (link, obj, filterRepeat = false) => {
  try {
    let url = new URL(link);
    for (let k in obj) {
      if (filterRepeat && url.searchParams.has(k)) {
        continue;
      }
      url.searchParams.set(k, String(obj[k]));
    }
    let commonParams = window.globalGetLinkParams();
    Object.keys(commonParams).forEach((key) => {
      url.searchParams.set(key, String(commonParams[key]));
    });
    return url.href;
  } catch (error) {
    return String(link);
  }
};

export const getGameId = () => {
  return (
    getParam("gameId") ||
    getParam("gameid") ||
    getParam("gameID") ||
    window.gameId ||
    ""
  );
};

export const getCurrentHost = () => {
  const matchHost = window.location.host.match(/\w+\.\w+$/)?.[0];
  return matchHost || "37games.com";
};

export const arrayRemove = (array, id) => {
  const index = array.indexOf(id);
  if (index > -1) {
    array.splice(index, 1);
  }
  return array;
};

export const isEmptyObject = (data) => {
  return Object.keys(data).length === 0;
};

// 打乱对象数组, lastNum为保留后面几项的顺序, -1：不打乱，0：全部打乱，1：保留最后一项，2：保留最后两项
export const shuffleObjectArray = (array, lastNum = 0) => {
  array.forEach((item, index) => (item.originIndex = index));
  if (lastNum < 0) {
    // 不打乱
    return array;
  }
  let target = lastNum ? array.slice(0, ~lastNum + 1) : array;
  let shuffleTarget = target.sort(() => Math.random() - 0.5);
  return lastNum
    ? [...shuffleTarget, ...array.slice(~lastNum + 1)]
    : shuffleTarget;
};

// 将对象装换成key=val&key=val的字符串
export const convertParamToString = function (params: {
  [x: string]: string;
}): string {
  const paramArray: string[] = [];
  for (const key in params) {
    let val = params[key];
    if ("object" === typeof val) {
      val = JSON.stringify(val);
    }
    const param = key + "=" + encodeURIComponent(val);
    paramArray.push(param);
  }
  // paramArray.push('callback');
  if (paramArray.length > 0) {
    return paramArray.join("&");
  }
  return "";
};

// 创建节流函数
export const throttle = (cb: any, time = 300) => {
  let timer: number | undefined = undefined;
  let bool = false;
  return () => {
    if (bool) {
      return;
    }
    bool = true;
    clearTimeout(timer);
    timer = window.setTimeout(() => {
      cb();
      bool = false;
    }, time);
  };
};

// 创建防抖函数
export const antiShake = (cb: any, time = 300) => {
  let timer: number | undefined = undefined;
  return () => {
    clearTimeout(timer);
    timer = window.setTimeout(() => {
      cb();
    }, time);
  };
};

const STORAGE_KEY_PRE = "survey_";

// localStorage 写入
export const setLocalStorage = (key: string, value: string) => {
  try {
    localStorage.setItem(STORAGE_KEY_PRE + key, value);
  } catch (e) {
    console.error(
      window.navigator.userAgent + "not support localStorage write",
      e
    );
  }
};

// localStorage 读取
export const getLocalStorage = (key: string) => {
  let value: string | null = "";
  try {
    value = localStorage.getItem(STORAGE_KEY_PRE + key);
  } catch (e) {
    console.error(
      window.navigator.userAgent + "not support localStorage read",
      e
    );
  }
  return value ? value : "";
};

export const getMainHost = () => {
  if (window.location.hostname == "localhost") {
    return "37games.com";
  }
  let hostArr = window.location.hostname.split(".");
  let mainArr = hostArr.slice(-2);
  return mainArr.join(".");
};

export const setCookie = (name: string, value: string, days: number) => {
  let date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  let expires = "; expires=" + date.toUTCString();
  document.cookie =
    name + "=" + value + expires + `;domain=${getMainHost()};path=/`;
};

export const getBranch = () => {
  return window.location.hostname.split(".")[1];
};

// 获取当前平台
export const getPlatform = (): string => {
  let branch = getBranch();
  let platformMap: Record<string, string> = {
    gm99: "gm99",
  };
  return platformMap[branch] || "global";
};

// 是否为SDK环境
export const runInsdk = () => {
  let runInAndroid =
    typeof window !== "undefined" &&
    window.sdkCtrl &&
    typeof window.sdkCtrl.callSDKMethodWithParameters == "function";
  let runInIOS =
    typeof window !== "undefined" &&
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.callSDKMethodWithParameters;
  return runInAndroid || runInIOS;
};
